import Swal from "sweetalert2";
import axios from "../../axios";
import { setAlert } from "./alert";
import { ADD_GLOBAL_BILL_CODE, DELETE_GLOBAL_BILL_CODE, GET_GLOBAL_BILL_CODES, UPDATE_GLOBAL_BILL_CODE, UPDATE_GLOBAL_BILL_CODE_STATUS } from "../types";
import { getErrorMessage } from "../../helpers/ErrorMessage";

export const addGlobalBillCode = (formData) => async (dispatch) => {
  try {
    const res = await axios.post("billcode/add", formData);
    if (res.data.code === 1) {
      dispatch({ type: ADD_GLOBAL_BILL_CODE, payload: res.data.data });
      Swal.fire({
        title: 'Success!',
        text: res.data.message,
        icon: 'success',
    });
      dispatch(setAlert(res.data.message, "success"));
      if (res.data.code === 0) {
        console.log("here :", res.data.message);  
        Swal.fire({
          title: 'warning!',
          text: res.data.message,
          icon: 'warning',
      });
    }
    } else {
      dispatch(setAlert(res.data.message, "warning"));
      Swal.fire({
        title: 'warning!',
        text: res.data.message,
        icon: 'warning',
      });
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
    // const errorMessage =
      // err.response?.data?.message || "An unexpected error occurred";
      const errorMessage = getErrorMessage(err.response?.data);

    Swal.fire({
      title: "Error!",
      text: errorMessage,
      icon: "error",
    });
  }
};
export const getGlobalBillCode = () => async (dispatch) => {
  try {
    const res = await axios.get("billcode/all");
    // console.log("state :", res.data);
    if (res.data.code === 1) {
      dispatch({ type: GET_GLOBAL_BILL_CODES, payload: res.data.data });
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
  }
};


export const updateGlobalBillCode = (formData) => async (dispatch) => {
  try {

    const updatedFormData = {
      id: formData.id,
      ...(formData.name && { name: formData.name }),
      ...(formData.code && { code: formData.code }),
      // ...(formData.status !== undefined && { status: formData.status }),
    };
    
    const res = await axios.post("billcode/update", updatedFormData);
    if (res.data.code === 1) {
      dispatch({ type: UPDATE_GLOBAL_BILL_CODE, payload: res.data.data });
      Swal.fire({
        title: 'Success!',
        text: res.data.message,
        icon: 'success',
    });
      dispatch(setAlert(res.data.message, "success"));
    } else {
      dispatch(setAlert(res.data.message, "warning"));
      Swal.fire({
        title: 'warning!',
        text: res.data.message,
        icon: 'warning',
    });
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
  }
};

export const updateGlobalBillCodeStatus = (formData) => async (dispatch) => {
  try {

    const updatedFormData = {
      id: formData.id,
      ...(formData.status !== undefined && { status: formData.status }),
    };
    
    const res = await axios.post("billcode/update/status", updatedFormData);
    if (res.data.code === 1) {
      dispatch({ type: UPDATE_GLOBAL_BILL_CODE_STATUS, payload: res.data.data });
      Swal.fire({
        title: 'Success!',
        text: res.data.message,
        icon: 'success',
    });
      dispatch(setAlert(res.data.message, "success"));
    } else {
      dispatch(setAlert(res.data.message, "warning"));
      Swal.fire({
        title: 'warning!',
        text: res.data.message,
        icon: 'warning',
    });
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
  }
};

export const deleteGlobalBillCode = (id) => async (dispatch) => {
  try {
    if (!id) {
      dispatch(setAlert("Please select any record", "warning"));
      return false;
    }
    const res = await axios.post(`billcode/delete/${id}`);
    if (res.data.code === 1) {
      dispatch({ type: DELETE_GLOBAL_BILL_CODE, payload: { id } });
      Swal.fire({
        title: 'Success!',
        text: res.data.message,
        icon: 'success',
    });
      dispatch(setAlert(res.data.message, "success"));
    } else {
      dispatch(setAlert(res.data.message, "warning"));
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
  }
};
